import AOS from "aos";

/*
 *
 * ----------------------------------------------- */
jQuery(window).on("load", function () {
  AOS.init();
});
